import React from "react";
import "./blog-post-archive.scss";
import { graphql } from "gatsby";
import Layout from "../components/layout/layout";
import Seo from "../components/seo";
import PostCardVertical from "../components/postCard/postCardVertical";
import Tabs from "../components/tabs/tabs";
import FeaturedPosts from "../components/featuredPosts/featuredPosts";
import Image from "gatsby-image";

const BlogIndex = ({ data, pageContext }) => {
  const posts = data?.allWpPost.nodes;
  const highlightPost = data?.highlightPost?.nodes;
  const bannerPost = data?.bannerPost?.nodes;

  const promotionalBannerImg = bannerPost
    ? {
      fluid:
          bannerPost.featuredImage?.node?.localFile
            ?.childImageSharp?.fluid,
      alt: bannerPost.featuredImage?.node?.alt || "",
    }
    : null;

  if (!posts?.length) {
    return (
      <Layout isHomePage>
        <Seo title="All posts" />
        <p>
          No blog posts found. Add posts to your WordPress
          site and they'll appear here!
        </p>
      </Layout>
    );
  }

  return (
    <Layout isHomePage>
      {pageContext.categorySlug !== "all-articles" ? (
        <Seo
          title={pageContext.categoryTitle}
          pageURI={`/${pageContext.categorySlug}`}
          meta={[
            {
              name: "robots",
              content: "noindex,follow",
            },
          ]}
        />
      ) : (
        <Seo
          title={pageContext.categoryTitle}
          meta={[
            {
              name: "robots",
              content: "index,follow",
            },
          ]}
        />
      )}

      {bannerPost ? (
        <div className="promotional-banner">
          {promotionalBannerImg?.fluid && (
            <Image
              fluid={promotionalBannerImg.fluid}
              alt={promotionalBannerImg.alt}
            />
          )}
        </div>
      ) : (
        ""
      )}
      <div className="all-posts">
        {highlightPost.length ? (
          <div className="content-left">
            <PostCardVertical
              post={highlightPost[0]}
              customClass={"highlight"}
              showDescription={true}
            />
          </div>
        ) : null}

        <div className="content-right">
          <FeaturedPosts posts={posts} />
        </div>
      </div>
      <Tabs
        {...data}
        categorySlug={pageContext.categorySlug}
        selectedCategory={data.categoriesList.nodes?.filter(
          item => item.slug === pageContext.categorySlug
        )}
      />
    </Layout>
  );
};

export default BlogIndex;

export const pageQuery = graphql`
  query WordPressPostArchive(
    $offset: Int!
    $postsPerPage: Int!
    $id: String!
  ) {
    allWpPost(
      sort: { fields: [date], order: DESC }
      limit: $postsPerPage
      skip: $offset
    ) {
      nodes {
        uri
        date(formatString: "DD/MM/YYYY")
        title
        excerpt
        featuredImage {
          node {
            altText
            localFile {
              childImageSharp {
                fluid(maxWidth: 700) {
                  ...GatsbyImageSharpFluid_tracedSVG
                }
              }
            }
          }
        }
        seo {
          readingTime
        }
        categories {
          nodes {
            id
            name
            uri
          }
        }
        tags {
          nodes {
            name
            id
          }
        }
      }
    }
    categoriesList: allWpCategory {
      nodes {
        id
        name
        count
        uri
        slug
      }
    }
    categoriesPost: allWpPost(
      filter: {
        categories: {
          nodes: { elemMatch: { id: { eq: $id } } }
        }
      }
      sort: { fields: [date], order: DESC }
    ) {
      nodes {
        uri
        date(formatString: "DD/MM/YYYY")
        title
        excerpt
        featuredImage {
          node {
            altText
            localFile {
              childImageSharp {
                fluid(maxWidth: 700) {
                  ...GatsbyImageSharpFluid_tracedSVG
                }
              }
            }
          }
        }
        seo {
          readingTime
        }
        categories {
          nodes {
            id
            name
            uri
          }
        }
      }
    }
    bannerPost: allWpPost(
      filter: {
        tags: {
          nodes: {
            elemMatch: {
              name: { eq: "Promotional Banner" }
            }
          }
        }
      }
      sort: { fields: [date], order: DESC }
    ) {
      nodes {
        uri
        date(formatString: "DD/MM/YYYY")
        title
        excerpt
        seo {
          readingTime
        }
        featuredImage {
          node {
            altText
            localFile {
              childImageSharp {
                fluid(maxWidth: 700) {
                  ...GatsbyImageSharpFluid_tracedSVG
                }
              }
            }
          }
        }
        categories {
          nodes {
            id
            name
            uri
          }
        }
      }
    }
    highlightPost: allWpPost(
      filter: {
        tags: {
          nodes: {
            elemMatch: { name: { eq: "Highlight Post" } }
          }
        }
      }
      sort: { fields: [date], order: DESC }
    ) {
      nodes {
        uri
        date(formatString: "DD/MM/YYYY")
        title
        excerpt
        featuredImage {
          node {
            altText
            localFile {
              childImageSharp {
                fluid(maxWidth: 700) {
                  ...GatsbyImageSharpFluid_tracedSVG
                }
              }
            }
          }
        }
        seo {
          readingTime
        }
        categories {
          nodes {
            id
            name
            uri
          }
        }
        tags {
          nodes {
            name
            id
          }
        }
      }
    }
  }
`;
